/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { Row, Form, Button, Input, Skeleton } from "antd";
import { LeftOutlined } from "@ant-design/icons";
import Layout from "../../../layout/Dashboard";
import { useHistory, useParams, Link } from "react-router-dom";
import "./add.css";
import firebase from "../../../config/FirebaseConfig";

export default function Update() {
  const history = useHistory();
  const { id } = useParams();
  const storage = firebase.storage();
  const ref = firebase.firestore().collection("articles");
  const [image, setImage] = useState("");
  const [article, setArticle] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const getData = () => {
      firebase
        .firestore()
        .collection("/articles")
        .doc(`${id}`)
        .get()
        .then((doc) => {
          if (!doc.exists) {
            console.log("No such document!");
          } else {
            console.log(doc.data());
            setArticle({
              id: doc.id,
              ...doc.data(),
            });
            setLoading(false);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    };
    getData();
  }, []);

  const handleFormSubmit = (values) => {
    storage
      .ref(`articles/${image.name}`)
      .put(image)
      .then(() => {
        storage
          .ref("articles")
          .child(image.name)
          .getDownloadURL()
          .then((url) => {
            console.log("Here");
            ref.doc(id).set({
              title: values.title,
              content: values.content,
              imgPath: url,
              createdAt: firebase.firestore.Timestamp.now(),
            });
            setTimeout(() => {
              history.push("/dashboard/article");
            }, 1000);
          })
          .catch((err) => {
            console.log(err);
          });
      });
  };

  const handleChange = (e) => {
    if (e.target.files[0]) {
      const image = e.target.files[0];
      setImage(image);
    }
  };

  return (
    <div id="article_create">
      <Layout>
        <div className="navbar">
          <Link to="/dashboard/article">
            <LeftOutlined /> &nbsp; Tulis Artikel
          </Link>
        </div>
        <Skeleton loading={loading}>
          <Form
            name="basic"
            className="form"
            onFinish={handleFormSubmit}
            initialValues={{
              title: article.title,
              content: article.content,
            }}
          >
            <Row justify="end" className="row">
              <Button className="button_secondary" htmlType="submit">
                Publish Artikel
              </Button>
            </Row>

            <Form.Item
              labelCol={{ span: 24 }}
              name="title"
              label="Judul"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Input />
            </Form.Item>

            <input type="file" onChange={handleChange} />
            <br />

            <Form.Item
              labelCol={{ span: 24 }}
              name="content"
              label="Isi Artikel"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Input.TextArea />
            </Form.Item>
          </Form>
        </Skeleton>
      </Layout>
    </div>
  );
}
